const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    INTERNAL_API_URL: 'https://2ludwr6ltd.execute-api.ap-southeast-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://q58qdb6pq8.execute-api.ap-southeast-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.nsr.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'Australia/Sydney'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.nsr.forwoodsafety.com'
  }
};

export default config;